<template>
	<v-dialog persistent @click:outside="closeDialog()" :value="dialog" max-width="450" scrollable >
		<v-card >
			<v-card-title>
				{{ $vuetify.lang.t('$vuetify.views.chat.usersList') }}
				<v-btn icon @click="closeDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-list>
					<div v-for="(user, i) in sortedUsers"
						:key="i">
						<v-divider v-if="i != 0" />
						<v-list-item
							class="py-1 d-flex flex-row align-items-center px-0"
						>
							<content-hover :user="user" user-name avatar hoverClass="d-flex flex-row align-items-center" @goTo="closeDialog()" />
							<!-- <v-btn icon class="ml-auto" @click="deleteUser(user)"><v-icon>mdi-delete</v-icon></v-btn> -->
						</v-list-item>
					</div>
				</v-list>
			</v-card-text>
			<v-card-actions class="py-3">
				<v-btn @click="closeDialog()" class="ml-auto"> {{ $vuetify.lang.t('$vuetify.close') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import ContentHover from '@/components/items/ContentHover';
import _ from 'lodash';
export default {
	props: {
		chat: {
			type: Object,
			required: true
		}
	},
	components: {
		ContentHover
	},
	data() {
		return {
			dialog: false,
			saving: false,
			fields: {
				users: []
			}
		}
	},
	computed: {
		sortedUsers() {
			return _.sortBy(this.chat.users, 'name');
		}
	},
	methods: {
		closeDialog() {
			this.dialog = false;
			this.$emit('close');
		},
		showDialog() {
			this.dialog = true;
		}
	}
}
</script>
